export default "__VITE_PUBLIC_ASSET__e15476b7__"